import { Locale } from '@nagel-types';

export const supportedLocales: Locale[] = [
    { localeCode: 'en-US', label: 'English' },
    { localeCode: 'de', label: 'Deutsch' },
];